import request from "@/utils/request";

export default function shipments(params) {
    return request({
        url: `/shopCar/agency/shipments`,
        method: 'post',
        data: params
    })
}
